module.exports = __webpack_public_path__ + "media/images/taxigo-platinum/offers-c1eb1740f334cde35bef8fe40ea1909e.svg";